package org.lennycodes.hldi.styles
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.alignSelf
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.outline
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.translateY
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.active
import com.varabyte.kobweb.silk.style.selectors.focusVisible
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.AlignSelf
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s
import org.lennycodes.hldi.constants.HLDITheme

val SubmitButtonStyle = CssStyle {
    base {
        Modifier
              .backgroundImage(
                linearGradient(
                    HLDITheme.Colors.accent,
                    HLDITheme.Colors.primary,
                    LinearGradient.Direction.ToLeft
                )
                )
            .color(HLDITheme.Colors.white)
            .border(0.px)
            .borderRadius(8.px)
            .fontSize(16.px)
            .fontWeight(600)
            .cursor(Cursor.Pointer)
            .alignSelf(AlignSelf.FlexStart)
            .transition(Transition.of(property = "all", duration = 0.3.s, timingFunction = TransitionTimingFunction.Ease))
    }

    hover {
        Modifier
            // reversed gradient instead of a flat backgroundColor,
            // so the swap is actually visible on top of backgroundImage
            .backgroundImage(
                linearGradient(
                    HLDITheme.Colors.accent,
                    HLDITheme.Colors.primary,
                    LinearGradient.Direction.ToRight
                )
            )
            .boxShadow(
                offsetY = 4.px,
                blurRadius = 16.px,
                color = Color.rgba(0, 0, 0, 0.15f) // swap for an accent-tinted rgba if you want a brand glow
            )
            .translateY((-2).px)
    }

    active {
        Modifier.translateY(0.px)
    }
}